import { render, staticRenderFns } from "./IconTotemFail.vue?vue&type=template&id=0e207a0c&scoped=true&"
var script = {}
import style0 from "./IconTotemFail.vue?vue&type=style&index=0&id=0e207a0c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e207a0c",
  null
  
)

export default component.exports